import React from 'react'
import RoofModel from './RoofModel'
import TrimModel from './TrimModel'

const Roof = () => {
    return (
        <group>
            <RoofModel />
            <TrimModel />
        </group>
    )
}

export default Roof